var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CFooter',{attrs:{"fixed":false}},[_c('div',[_c('CLink',{attrs:{"to":{ name: 'home' },"target":"_blank"}},[_vm._v("Delovery")]),_c('span',{staticClass:"ml-1"},[_vm._v("© "+_vm._s(new Date().getFullYear())+" Copyright.")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }